var tabLinks = document.querySelectorAll(".tablinks");
var tabContent = document.querySelectorAll(".tabcontent");

for (var i = 0; i < tabLinks.length; i++) {
   tabLinks[i].addEventListener("click", openTabs);
}

function openTabs(el) {
   var btnTarget = el.currentTarget;
   var country = btnTarget.dataset.country;

   for (var i = 0; i < tabContent.length; i++) {
      tabContent[i].classList.remove("active");
   }

   for (var i = 0; i < tabLinks.length; i++) {
      tabLinks[i].classList.remove("active");
   }

   document.querySelector("#" + country).classList.add("active");
   btnTarget.classList.add("active");
}
document.addEventListener("DOMContentLoaded", function() {
    var tabLinks = document.querySelectorAll(".tablinks");
    var tabContent = document.querySelectorAll(".tabcontent");
    
    for (var i = 0; i < tabLinks.length; i++) {
       tabLinks[i].addEventListener("click", openTabs);
    }
    
    function openTabs(el) {
       var btnTarget = el.currentTarget;
       var country = btnTarget.dataset.country;
    
       for (var i = 0; i < tabContent.length; i++) {
          tabContent[i].classList.remove("active");
       }
    
       for (var i = 0; i < tabLinks.length; i++) {
          tabLinks[i].classList.remove("active");
       }
    
       document.querySelector("#" + country).classList.add("active");
       btnTarget.classList.add("active");
    }
    // Initialize the dropdown menu and set up the initial selected text
    var dropdownMenu = document.querySelector('.dropdown-menu');
    var dropdownSelected = document.querySelector('.dropdown-toggle span'); // Selecting span inside toggle
    var firstItem = dropdownMenu.querySelector('.dropdown-item');
    
    // Set the first item as the selected text for the dropdown
    if (firstItem) {
        dropdownSelected.textContent = firstItem.textContent;
    }

    // Add click event to each dropdown item
    var dropdownItems = dropdownMenu.querySelectorAll('.dropdown-item');
    dropdownItems.forEach(function(item) {
        item.addEventListener('click', function(event) {
            event.preventDefault(); // Prevent default link behavior

            // Update the dropdown-selected text to the clicked item's text
            dropdownSelected.textContent = item.textContent;

            // Switch to the corresponding tab content
            var country = item.dataset.country;
            switchToTab(country);

            // Hide the dropdown after selection
            dropdownMenu.style.display = 'none';
            document.querySelector('.wrapper_tabcontent').classList.remove('move-down');
        });
    });
});

// Function to switch to the corresponding tab content based on the selected dropdown item
function switchToTab(country) {
    var tabContent = document.querySelectorAll('.tabcontent');
    var tabLinks = document.querySelectorAll('.tablinks');

    // Remove 'active' class from all tab contents and tab links
    tabContent.forEach(function(content) {
        content.classList.remove("active");
    });

    tabLinks.forEach(function(link) {
        link.classList.remove("active");
    });

    // Add 'active' class to the selected tab content
    var activeTabContent = document.querySelector("#" + country);
    if (activeTabContent) {
        activeTabContent.classList.add("active");
    }

    // Also add 'active' class to the corresponding tab link (if it exists)
    var correspondingTabLink = document.querySelector('.tablinks[data-country="' + country + '"]');
    if (correspondingTabLink) {
        correspondingTabLink.classList.add("active");
    }
}

// Function to toggle the visibility of the dropdown menu
function toggleDropdown() {
    var dropdownMenu = document.querySelector('.dropdown-menu');
    var wrapperTabcontent = document.querySelector('.wrapper_tabcontent');

    if (dropdownMenu.style.display === 'block') {
        dropdownMenu.style.display = 'none';
        wrapperTabcontent.classList.remove('move-down');
    } else {
        dropdownMenu.style.display = 'block';
        wrapperTabcontent.classList.add('move-down');
    }
}

// Close the dropdown if the user clicks outside of it
window.onclick = function(event) {
    if (!event.target.matches('.dropdown-toggle') && !event.target.closest('.dropdown-menu')) {
        var dropdowns = document.getElementsByClassName("dropdown-menu");
        for (var i = 0; i < dropdowns.length; i++) {
            var openDropdown = dropdowns[i];
            if (openDropdown.style.display === 'block') {
                openDropdown.style.display = 'none';
                document.querySelector('.wrapper_tabcontent').classList.remove('move-down');
            }
        }
    }
};